<ngb-pagination
  *ngIf="itemsCount > size"
  [collectionSize]="itemsCount"
  [pageSize]="size"
  [(page)]="page"
  [maxSize]="visiblePages"
  [boundaryLinks]="true"
  (pageChange)="onPageChange($event)"
></ngb-pagination>
